// components/Notification.jsx
import React from 'react';

const Notification = ({ message, type }) => {
  return (
    <div className={`fixed bottom-4 left-4 px-6 py-3 rounded-lg shadow-lg z-50 ${
      type === 'success' ? 'bg-green-600' : 'bg-red-600'
    }`}>
      <p className="text-white">{message}</p>
    </div>
  );
};

export default Notification;